"use client";

import { TrashIcon } from "@heroicons/react/24/solid";
import { ReactNode } from "react";

import { BigAudioPlayer } from "@/components/audioPlayers/BigAudioPlayer";
import { LoadingEllipsis } from "@/components/uploadingFiles/LoadingEllipsis";
import { ProgressRing } from "@/components/uploadingFiles/ProgressRing";
import { AudioInputState, SelectedFile } from "@/types/types";

export function FilePresentation({
  selectedFile,
  clearInput,
  hideClearButton,
  footerSlot,
}: {
  selectedFile: SelectedFile;
  clearInput: AudioInputState["clearInput"];
  hideClearButton: boolean;
  footerSlot: ReactNode;
}) {
  const uploadingAboutToStart =
    selectedFile.progress !== null && selectedFile.progress === 0;

  return (
    <div className="flex flex-col rounded-3xl bg-white px-4 py-2 shadow-sm ring-1 ring-gray-900/5">
      <div className="flex items-center justify-between gap-x-2">
        <BigAudioPlayer
          source={selectedFile.selectedUrl}
          includePreviewText={false}
          bigWaves={false}
          filename={
            selectedFile.selectedSound === null ?
              null
            : selectedFile.selectedSound.filename
          }
          className="w-full"
        />

        {uploadingAboutToStart && (
          <div>
            <LoadingEllipsis />
          </div>
        )}

        {selectedFile.progress !== null && !uploadingAboutToStart && (
          <div className="h-6 w-6">
            <ProgressRing progress={selectedFile.progress} />
          </div>
        )}

        {!hideClearButton && (
          <button aria-label="Remove input vocal" onClick={() => clearInput()}>
            <TrashIcon className="h-6 w-6" />
          </button>
        )}
      </div>

      {footerSlot}
    </div>
  );
}
